module.exports = __webpack_public_path__ + "img/new2-img3.1dd08c83.png";